export const DEFAULT_LIMIT = 20

export const initialTableReducer = {
  items: [],
  limit: DEFAULT_LIMIT,
  offset: 0,
  total: 0
}

export const TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss'

export enum CertificateStatuses {
  ISSUED = 'issued',
  REVOKED = 'revoked',
  EXPIRED = 'expired'
}

export enum FeatureFlags {
  ENABLE_ACTIVATE_STEP = 'enableActivateStepForDsmSigner'
}

export const DIGIROOT_ID = '00000000-0000-0000-0000-000000000000'

export enum AccountFeatures {
  STM_TRIAL_ACCOUNT = 'ftr_sm_trial_account',
  STM_KEYLOCKER_ACCOUNT ='ftr_sm_keylocker_account',
  STM_PUBLIC_ISSUANCE = 'ftr_sm_public_issuance',
  TLM_CERT_MANAGEMENT = 'ftr_em_auto_cert_mgmt'
}

export const SystemAccount = 'System Account'

export enum STMApplicationName {
  SECURE_SOFTWARE = 'Software Trust',
  KEYLOCKER = 'KeyLocker'
}

export const DISABLED = 'disabled'
export const DISABLE = 'disable'
export const ENABLE = 'enable'
export const EXPIRED = 'expired'
export const ENABLED = 'enabled'
export const VALID = 'valid'
export const CERT_CENTRAL_SHORT_APP_CODE = 'CC'

export enum AppTypes {
  EXTERNAL = 'EXTERNAL',
  INTERNAL_SERVICE = 'INTERNAL_SERVICE'
}

export enum CreateUserTypes {
  DIGICERT_USER = 'digicert-user',
  ACCOUNT_USER = 'account-user'
}

export enum ShortAppCodes {
  CERT_CENTRAL = 'CC',
  TRUST_LIFECYCLE = 'TM',
  IOT = 'IOT',
  SOFTWARE_TRUST = 'SM',
  DOCUMENT_TRUST = 'DTM'
}